import { render, staticRenderFns } from "./SongLoader.vue?vue&type=template&id=02a4b0ae&scoped=true&"
import script from "./SongLoader.vue?vue&type=script&lang=js&"
export * from "./SongLoader.vue?vue&type=script&lang=js&"
import style0 from "./SongLoader.vue?vue&type=style&index=0&id=02a4b0ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a4b0ae",
  null
  
)

export default component.exports